import axios from "axios";
import { getToken } from "./auth";
import { appUrl } from "./utilities";
import extSecurity from "./extAuth";


export const fetchQuery = async (
  url = "",
  auth = true,
  isExternal = false,
  config
) => {
  try {
    if (auth && !isExternal)
      axios.defaults.headers.common["token"] = getToken();
    if (auth && isExternal) {
      axios.defaults.headers.common["Authorization"] = extSecurity.getToken();
      axios.defaults.headers.common["X-API-KEY"] =
        process.env.REACT_APP_RIVIAOS_API_KEY;
    }

    const res = await axios.get(`${appUrl}/${url}`, config);
    return res;
  } catch (ex) {
    return ex;
  }
};

export const postQuery = async (
  url = "",
  data = {},
  auth = true,
  isExternal = false,
  config
) => {
  try {
    if (auth && !isExternal)
      axios.defaults.headers.common["token"] = getToken();
    if (auth && isExternal) {
      axios.defaults.headers.common["Authorization"] = extSecurity.getToken();
      axios.defaults.headers.common["X-API-KEY"] =
        process.env.REACT_APP_RIVIAOS_API_KEY;
    }

    const res = await axios.post(`${appUrl}/${url}`, data, config);
    return res;
  } catch (ex) {
    return ex;
  }
};

export const updateQuery = async (
  url = "",
  data = {},
  auth = true,
  isExternal = false,
  config
) => {
  try {
    if (auth && !isExternal)
      axios.defaults.headers.common["token"] = getToken();
    if (auth && isExternal) {
      axios.defaults.headers.common["Authorization"] = extSecurity.getToken();
      axios.defaults.headers.common["X-API-KEY"] =
        process.env.REACT_APP_RIVIAOS_API_KEY;
    }

    const res = await axios.put(`${appUrl}/${url}`, data, config);
    return res;
  } catch (ex) {
    return ex;
  }
};


// const toDatedItem = (item = {}) => {
//   const createdAt = item?.createdAt ?? item?.date ?? null;
//   const { createdAt: _createdAt, ...rest } = item || {};
//   return { ...rest, date: createdAt };
// };

// const toAgentVisitDetailsShape = (consultation = {}) => {
//   if (!consultation || typeof consultation !== "object") return null;

//   const createdAt = consultation?.createdAt ?? consultation?.date ?? null;
//   const {
//     createdAt: _createdAt,
//     doctorReviews,
//     diagnosis,
//     vitals,
//     laboratories,
//     nursingNotes,
//     ...rest
//   } = consultation;

//   const normalizedVitals = vitals
//     ? (() => {
//         const vCreatedAt = vitals?.createdAt ?? vitals?.date ?? null;
//         const { createdAt: _vCreatedAt, ...vRest } = vitals;
//         return { ...vRest, date: vCreatedAt };
//       })()
//     : null;

//   return {
//     ...rest,
//     date: createdAt,
//     vitals: normalizedVitals,
//     diagnosis: Array.isArray(diagnosis) ? diagnosis.map(toDatedItem) : [],
//     reviews: Array.isArray(doctorReviews) ? doctorReviews.map(toDatedItem) : [],
//     laboratories: Array.isArray(laboratories)
//       ? laboratories.map(toDatedItem)
//       : [],
//     nursingNotes: Array.isArray(nursingNotes) ? nursingNotes.map(toDatedItem) : [],
//   };
// };

export const getMoremiDecisionSupport = async ( data = null) => {
  const qry = await postQuery(
    "consultations/ai/decision-support",
    data || {},
    true
  );
  return qry.data?.data;
};

/** Moremi AI: clinical_summary report for a consultation visit. */
export const getMoremiMedicalReport = async (consultationId) => {
  const qry = await postQuery(
    "consultations/ai/medical-report",
    { consultationId: String(consultationId) },
    true
  );
  if (qry?.response) {
    const err = new Error(
      qry.response?.data?.message || "Medical report generation failed."
    );
    err.response = qry.response;
    throw err;
  }
  return qry.data?.data ?? qry.data;
};

export const patchQuery = async (
  url = "",
  data = {},
  auth = true,
  isExternal = false,
  config
) => {
  try {
    if (auth && !isExternal)
      axios.defaults.headers.common["token"] = getToken();
    if (auth && isExternal) {
      axios.defaults.headers.common["Authorization"] = extSecurity.getToken();
      axios.defaults.headers.common["X-API-KEY"] =
        process.env.REACT_APP_RIVIAOS_API_KEY;
    }

    const res = await axios.patch(`${appUrl}/${url}`, data, config);
    return res;
  } catch (ex) {
    return ex;
  }
};

export const deleteQuery = async (
  url = "",
  config,
  auth = true,
  isExternal = false
) => {
  try {
    if (auth && !isExternal)
      axios.defaults.headers.common["token"] = getToken();
    if (auth && isExternal) {
      axios.defaults.headers.common["Authorization"] = extSecurity.getToken();
      axios.defaults.headers.common["X-API-KEY"] =
        process.env.REACT_APP_RIVIAOS_API_KEY;
    }

    const res = await axios.delete(`${appUrl}/${url}`, config);
    return res;
  } catch (ex) {
    return ex;
  }
};

// requests

// GET

// users
export const getAllUsers = async () => {
  const qry = await fetchQuery(`accounts`);
  return qry.data.data;
};

export const getAllLogs = async (facilityId) => {
  const qry = await fetchQuery(`accounts/logs/${facilityId}`);
  return qry.data.data;
};

export const getUser = async (id) => {
  const qry = await fetchQuery(`accounts/${id}`);
  return qry.data.data;
};

export const getUserProfile = async (id) => {
  const qry = await fetchQuery(`accounts/${id}/profile`);
  return qry.data.data;
};

export const getUserBranches = async (id) => {
  const qry = await fetchQuery(`accounts/${id}/branches`);
  return qry.data.data;
};

export const getRefreshToken = async () => {
  const qry = await fetchQuery(`accounts/refresh-token`);
  return qry.data;
};

export const putActivateUser = async (userId) => {
  return await updateQuery(`accounts/${userId}/activate`);
};

export const putSuspendUser = async (userId) => {
  return await updateQuery(`accounts/${userId}/deactivate`);
};

export const putUpdateUser = async (data) => {
  return await updateQuery(`accounts`, data);
};

export const deleteUser = async (userId) => {
  return await deleteQuery(`accounts/${userId}`);
};

// patients
export const getAllPatients = async () => {
  // const qry = await fetchQuery( `patients?entireNetwork=${ true }` );
  const qry = await fetchQuery(`patients`);
  return qry.data.data;
};

export const getAllNetworkPatients = async () => {
  const qry = await fetchQuery(`patients?entireNetwork=${true}`);
  return qry.data.data;
};

export const getPatient = async (id) => {
  const qry = await fetchQuery(`patients/${id}`);
  return qry.data.data;
};

export const getPatientMedicalHistory = async (id) => {
  const qry = await fetchQuery(`patients/${id}/medical-history`);
  return qry.data.data;
};

export const getPatientMedicalReports = async (id) => {
  const qry = await fetchQuery(`patients/${id}/medical-reports`);
  return qry.data.data;
};

export const getPatientMedicalReportById = async (patientId, reportId) => {
  const qry = await fetchQuery(
    `patients/${patientId}/medical-reports/${reportId}`
  );
  return qry.data.data;
};

export const postNewPatient = async (patient) => {
  return await postQuery("patients", patient);
};

export const putUpdatePatient = async (patient) => {
  return await updateQuery(`patients`, patient);
};

export const putUpdatePatientMedicalHistory = async (data) => {
  return await updateQuery(`patients/medical-history`, data);
};

export const deletPatient = async (id) => {
  return await deleteQuery(`patients/${id}`);
};

export const postPatientMedicalReport = async (patientId, data) => {
  return await postQuery(`patients/${patientId}/medical-reports`, data);
};

export const putPatientMedicalReport = async (patientId, reportId, data) => {
  return await updateQuery(
    `patients/${patientId}/medical-reports/${reportId}`,
    data
  );
};

export const deletePatientMedicalReport = async (patientId, reportId) => {
  return await deleteQuery(
    `patients/${patientId}/medical-reports/${reportId}`
  );
};

// staffs
export const getAllStaffGroups = async () => {
  const qry = await fetchQuery(`staffs/groups`);
  return qry.data.data;
};

export const getAllStaffs = async () => {
  const qry = await fetchQuery(`staffs`);
  return qry.data.data;
};

export const getStaff = async (id) => {
  const qry = await fetchQuery(`staffs/${id}`);
  return qry.data.data;
};

export const patchDoctorSignatureStamp = async (staffId, data) => {
  return await patchQuery(`staffs/${staffId}/signature-stamp`, data);
};

export const postStaffSignatureImage = async (staffId, formData) => {
  return await postQuery(`staffs/${staffId}/signature`, formData);
};

export const postStaffStampImage = async (staffId, formData) => {
  return await postQuery(`staffs/${staffId}/stamp`, formData);
};

// services
export const getAllServiceGroups = async () => {
  return await fetchQuery(`services/groups`);
};

export const getAllServices = async () => {
  const qry = await fetchQuery(`services`);
  return qry.data.data;
};

export const getService = async (id) => {
  const qry = await fetchQuery(`services/${id}`);
  return qry.data.data;
};

export const putFacilityService = async (data) => {
  return await updateQuery(`services`, data);
};

export const postFacilityService = async (data) => {
  return await postQuery(`services`, data);
};

export const deleteFacilityService = async (id) => {
  return await deleteQuery(`services/${id}`);
};

// services - bulk upload / download (facility admins & superusers only)
export const getServiceUploadTemplate = async () => {
  return await fetchQuery(`services/upload-template`, true, false, {
    responseType: "blob",
  });
};

export const exportFacilityServices = async () => {
  return await fetchQuery(`services/export`, true, false, {
    responseType: "blob",
  });
};

export const uploadFacilityServices = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return await postQuery(`services/upload`, formData);
};

// BILLS
export const getAllBills = async () => {
  const qry = await fetchQuery(`bills`);
  return qry.data.data;
};

export const getBill = async (id) => {
  const qry = await fetchQuery(`bills/${id}`);
  return qry.data.data;
};

// export const getBillByReceiptNumber = async ( number ) => {
//   const qry = await fetchQuery( `bills/receipts/${ number }` );
//   return qry.data.data;
// };

/**
 * Retrieves a bill receipt based on the specified value and query.
 *
 * @param {any} query - The value used to search for the receipt.
 * @param {string} param - The type of query to perform. Default is either "billId" or "receiptNumber".
 * @return {Promise} The data of the retrieved bill receipt.
 */
export const getBillReceipt = async (
  param = "billId" | "receiptNumber",
  query
) => {
  const qry = await fetchQuery(`bills/receipts/${param}/${query}`);
  return qry.data.data;
};

export const putBill = async (data, files = null, attachmentsToKeep = null) => {
  if (files?.length || (attachmentsToKeep !== undefined && attachmentsToKeep !== null)) {
    const form = new FormData();
    form.append("bill", JSON.stringify(data.bill));
    form.append("items", JSON.stringify(data.items));
    form.append("payments", JSON.stringify(data.payments));
    form.append("charges", JSON.stringify(data.charges || []));
    if (attachmentsToKeep !== undefined) form.append("attachments", JSON.stringify(attachmentsToKeep));
    (files || []).forEach((f) => form.append("files", f));
    return await updateQuery("bills", form);
  }
  return await updateQuery(`bills`, data);
};

export const putLinkBillToConsultation = async (billId, code) => {
  return await updateQuery(`bills/${billId}/link-consultation/${code}`);
};

export const postBill = async (data, files = null) => {
  if (files?.length) {
    const form = new FormData();
    form.append("bill", JSON.stringify(data.bill));
    form.append("items", JSON.stringify(data.items || []));
    form.append("payments", JSON.stringify(data.payments || []));
    form.append("charges", JSON.stringify(data.charges || []));
    if (data.submitForReimbursement) form.append("submitForReimbursement", "true");
    files.forEach((f) => form.append("files", f));
    return await postQuery(`bills`, form);
  }
  return await postQuery(`bills`, data);
};

export const postBillDraft = async (data, files = null) => {
  if (files?.length) {
    const form = new FormData();
    form.append("bill", JSON.stringify(data.bill));
    form.append("items", JSON.stringify(data.items));
    form.append("payments", JSON.stringify(data.payments || []));
    form.append("charges", JSON.stringify(data.charges || []));
    files.forEach((f) => form.append("files", f));
    return await postQuery(`bills/draft`, form);
  }
  return await postQuery(`bills/draft`, data);
};

export const postBillCheckout = async (data, files = null) => {
  return postBill(data, files);
};

export const putConvertBillToDraft = async (billId) => {
  return await updateQuery(`bills/${billId}/convert-to-draft`);
};

export const deleteBill = async (id) => {
  return await deleteQuery(`bills/${id}`);
};

// service providers
export const getAllInsuranceProviders = async () => {
  const qry = await fetchQuery(`insurances`);
  return qry.data.data;
};

export const getInsuranceProvider = async (id) => {
  const qry = await fetchQuery(`insurances/${id}`);
  return qry.data.data;
};

export const getAllInsuranceTypes = async () => {
  const qry = await fetchQuery(`insurances/types`);
  return qry.data.data;
};

export const getAllLaboratories = async () => {
  const qry = await fetchQuery(`laboratories`);
  return qry.data.data;
};

export const getLaboratory = async (id) => {
  const qry = await fetchQuery(`laboratories/${id}`);
  return qry.data.data;
};

export const getAllPharmacies = async () => {
  const qry = await fetchQuery(`pharmacies`);
  return qry.data.data;
};

export const getPharmacy = async (id) => {
  const qry = await fetchQuery(`pharmacies/${id}`);
  return qry.data.data;
};

// appointments
export const getAllAppointments = async () => {
  const qry = await fetchQuery(`appointments`);
  return qry.data.data;
};

export const getAppointmentsById = async (id) => {
  const qry = await fetchQuery(`appointments/${id}`);
  return qry.data.data;
};

export const postNewAppointment = async (appointment) => {
  return await postQuery("appointments", appointment);
};

export const putAppointment = async (data) => {
  return await updateQuery(`appointments`, data);
};

export const patchCompleteAppointment = async (id) => {
  return await patchQuery(`appointments/${id}/complete`);
};

export const patchCancelAppointment = async (id, cancelReason) => {
  return await patchQuery(`appointments/${id}/cancel`, cancelReason);
};

export const deleteAppointment = async (id) => {
  return await deleteQuery(`appointments/${id}`);
};

// auth
export const postSignup = async (user) => {
  return await postQuery("accounts/signup", user);
};

export const postLogin = async (user) => {
  return await postQuery("accounts/login", user, false);
};

export const postChangePassword = async (user) => {
  return await postQuery("accounts/change-password", user);
};

export const postForgotPassword = async (email) => {
  return await postQuery("accounts/forgot-password", email, false);
};

export const postAttendance = async (data) => {
  return await postQuery(`accounts/attendance`, data);
};

export const putAttendance = async (data) => {
  return await updateQuery(`accounts/attendance`, data);
};

export const putLogOut = async () => {
  return await updateQuery(`accounts/logout`);
};

export const putSwitchBranch = async (id) => {
  return await updateQuery(`accounts/switch-branch/${id}`);
};

export const putSwitchFacility = async (id) => {
  return await updateQuery(`accounts/switch-facility/${id}`);
};

export const postInviteFacilityUser = async (data) => {
  return await postQuery("accounts/invite", data);
};

export const postAcceptFacilityInvitation = async (data) => {
  return await postQuery("accounts/accept", data, false);
};

// staff
export const postNewStaff = async (staff) => {
  return await postQuery("staffs", staff);
};

export const putUpdateStaff = async (staff) => {
  return await updateQuery("staffs", staff);
};

export const postNewStaffGroup = async (group) => {
  return await postQuery("staffs/groups", group);
};

export const deleteStaff = async (id) => {
  return await deleteQuery(`staffs/${id}`);
};

// services
export const postNewServiceGroup = async (group) => {
  return await postQuery("services/groups", group);
};

export const postNewService = async (service) => {
  return await postQuery("services", service);
};

// service providers
export const postNewInsurance = async (insurance) => {
  // return await axios.post(appUrl + "/insurances", insurance);
  return await postQuery("insurances", insurance);
};

export const putUpdateInsurance = async (insur) => {
  return await updateQuery("insurances", insur);
};

export const deleteInsurance = async (id) => {
  return await deleteQuery(`insurances/${id}`);
};

// insurance type
export const postNewInsuranceType = async (type) => {
  return await postQuery("insurances/types", type);
};

export const putUpdateInsuranceType = async (insurType) => {
  return await updateQuery("insurances/types", insurType);
};

// laboratories
export const postNewLaboratory = async (lab) => {
  return await postQuery("laboratories", lab);
};

export const putUpdateLaboratory = async (lab) => {
  return await updateQuery("laboratories", lab);
};

export const deleteLaboratory = async (id) => {
  return await deleteQuery(`laboratories/${id}`);
};

// pharmacies
export const postNewPharmacy = async (pharma) => {
  return await postQuery("pharmacies", pharma);
};

export const putUpdatePharmacy = async (pharma) => {
  return await updateQuery("pharmacies", pharma);
};

export const deletePharmacy = async (id) => {
  return await deleteQuery(`pharmacies/${id}`);
};

// consultation
export const postNewConsultation = async (consultation) => {
  return await postQuery("consultations", consultation);
};

export const postUploadConsultationFiles = async (id, files) => {
  return await postQuery(`consultations/${id}/files`, files, true);
};

export const deleteConsultationFile = async (consultationId, fileId) => {
  return await deleteQuery(
    `consultations/${consultationId}/files/${fileId}`,
    true
  );
};

export const putUpdateConsultationStatus = async (id) => {
  return await updateQuery(`consultations/${id}/toggle-status`);
};

export const deleteConsultation = async (id) => {
  return await deleteQuery(`consultations/${id}`);
};

export const getConsultationByCode = async (code) => {
  return await fetchQuery(`consultations/${code}/code`);
};

export const getConsultationById = async (id) => {
  // return await fetchQuery( `consultations/${ id }` );
  const qry = await fetchQuery(`consultations/${id}`);
  return qry.data.data;
};

export const getConsultationFeedback = async (id) => {
  // return await fetchQuery( `consultations/${ id }` );
  const qry = await fetchQuery(`consultations/${id}/feedback`);
  return qry.data.data;
};

export const getConsultationsByPatient = async (patientId) => {
  const qry = await fetchQuery(`consultations/patient/${patientId}`);
  return qry.data.data;
};

export const getAllConsultations = async () => {
  const qry = await fetchQuery(`consultations`);
  return qry.data.data;
};

export const getSendReminder = async (id) => {
  return await fetchQuery(`consultations/${id}/reminder`);
};

// subsets
export const getConsultationOnly = async (id) => {
  const qry = await fetchQuery(`consultations/${id}/light`);
  return qry.data.data;
};

export const getCareplans = async (id) => {
  const qry = await fetchQuery(`consultations/${id}/careplans`);
  return qry.data.data;
};

export const getCareplanById = async (id) => {
  const qry = await fetchQuery(`consultations/careplans/${id}`);
  return qry.data.data;
};

export const getVitals = async (id) => {
  const qry = await fetchQuery(`consultations/${id}/vitals`);
  return qry.data.data;
};

export const getDiagnosis = async (id) => {
  const qry = await fetchQuery(`consultations/${id}/diagnosis`);
  return qry.data.data;
};

export const getReviews = async (id) => {
  const qry = await fetchQuery(`consultations/${id}/reviews`);
  return qry.data.data;
};

export const getPrescriptions = async (id) => {
  const qry = await fetchQuery(`consultations/${id}/prescriptions`);
  return qry.data.data;
};

export const getPharmacies = async (id) => {
  const qry = await fetchQuery(`consultations/${id}/pharmacies`);
  return qry.data.data;
};

export const getLaboratories = async (id) => {
  const qry = await fetchQuery(`consultations/${id}/laboratories`);
  return qry.data.data;
};

export const getExcuseDuties = async (code) => {
  const qry = await fetchQuery(`consultations/${code}/excuse-duties`);
  return qry.data.data;
};

export const getExcuseDuty = async (code, id) => {
  const qry = await fetchQuery(`consultations/${code}/excuse-duties/${id}`);
  return qry.data.data;
};

export const getBranchExcuseDuties = async () => {
  const qry = await fetchQuery(`consultations/excuse-duties`);
  return qry.data.data;
};

export const postExcuseDuty = async (data) => {
  return await postQuery(`consultations/excuse-duties`, data);
};

export const postCareplan = async (data) => {
  return await postQuery(`consultations/careplans`, data);
};

// update subsets
export const putCarePlan = async (data) => {
  return await updateQuery(`consultations/careplans`, data);
};

export const putConsultationOnly = async (data) => {
  return await updateQuery(`consultations/`, data);
};

export const putVitals = async (id, data) => {
  return await updateQuery(`consultations/${id}/vitals`, data);
};

export const putDiagnosis = async (id, data) => {
  return await updateQuery(`consultations/${id}/diagnosis`, data);
};

export const putReviews = async (id, data) => {
  return await updateQuery(`consultations/${id}/reviews`, data);
};

export const putPrescriptions = async (id, data) => {
  return await updateQuery(`consultations/${id}/prescriptions`, data);
};

export const putPharmacies = async (id, data) => {
  return await updateQuery(`consultations/${id}/pharmacies`, data);
};

export const putLaboratories = async (id, data) => {
  return await updateQuery(`consultations/${id}/laboratories`, data);
};

export const deleteCarePlan = async (id) => {
  return await deleteQuery(`consultations/careplans/${id}`);
};

// Nursing Notes API Methods
export const getNursingNotes = async (id) => {
  const qry = await fetchQuery(`consultations/${id}/nursing-notes`);
  return qry.data.data;
};

export const getNursingNoteById = async (id) => {
  const qry = await fetchQuery(`consultations/nursing-notes/${id}`);
  return qry.data.data;
};

export const postNursingNote = async (data) => {
  return await postQuery(`consultations/nursing-notes`, data);
};

export const putNursingNote = async (data) => {
  return await updateQuery(`consultations/nursing-notes`, data);
};

export const deleteNursingNote = async (id) => {
  return await deleteQuery(`consultations/nursing-notes/${id}`);
};

// call
export const getVideoCall = async (roomId) => {
  return await fetchQuery(`calls/video/${roomId}`, true);
};

export const getAllCalls = async () => {
  const qry = await fetchQuery(`calls`);
  return qry.data.data;
};

export const getVideoCallInvite = async (meetingId, patientId) => {
  return await fetchQuery(`calls/invite/${meetingId}/${patientId}`);
};

export const postNewCall = async (call) => {
  return await postQuery("calls", call);
};

export const deleteExitVideoCall = async (roomId) => {
  return await deleteQuery(`calls/video/${roomId}`);
};

// reports
export const getConsultationsReport = async () => {
  const qry = await fetchQuery(`reports/consultations`);
  return qry.data.data;
};

export const getCallsReport = async () => {
  const qry = await fetchQuery(`reports/calls`);
  return qry.data.data;
};

export const getBillsReport = async () => {
  const qry = await fetchQuery(`reports/bills`);
  return qry.data.data;
};

export const getPrescriptionsReport = async () => {
  const qry = await fetchQuery(`reports/prescriptions`);
  return qry.data.data;
};

export const getLaboratoriesReport = async () => {
  const qry = await fetchQuery(`reports/laboratories`);
  return qry.data.data;
};

export const getDiagnosisReport = async () => {
  const qry = await fetchQuery(`reports/diagnosis`);
  return qry.data.data;
};

// list
export const getAllDrugs = async () => {
  const qry = await fetchQuery(`lists/drugs`);
  return qry.data.data;
};
export const getAllDiagnosis = async () => {
  const qry = await fetchQuery(`lists/diagnosis`);
  return qry.data.data;
};
export const getAllInvestigations = async () => {
  const qry = await fetchQuery(`lists/investigations`);
  return qry.data.data;
};
export const getAllSymptoms = async () => {
  const qry = await fetchQuery(`lists/symptoms`);
  return qry.data.data;
};
export const getAllLabActivities = async () => {
  const qry = await fetchQuery(`lists/lab-activities`);
  return qry.data.data;
};

// post list

export const postNewDrug = async (data) => {
  return await postQuery("lists/drugs", data);
};

export const postNewLabActivity = async (data) => {
  return await postQuery("lists/lab-activities", data);
};

export const postNewDiagnosis = async (data) => {
  return await postQuery("lists/diagnosis", data);
};

// external (service providers)
export const getExtProviderConsultation = async (code) => {
  // const qry = await fetchQuery( `v1/ext/consultations/${ code }/service-provider`, true, true );
  return await fetchQuery(
    `v1/ext/consultations/${code}/service-provider`,
    true,
    true
  );
  // return qry.data.data;
};

export const getExtPatientConsultation = async (code, hashcode) => {
  return await fetchQuery(
    `v1/ext/consultations/${code}/patient/${hashcode}`,
    true,
    true
  );
  // return qry.data.data;
};

//
export const getExtConsultations = async () => {
  // category = pharmacy or laboratory
  // return await fetchQuery( `v1/ext/consultations`, true, true );
  const qry = await fetchQuery(`v1/ext/consultations`, true, true);
  return qry.data.data;
};

export const putLabReport = async (data, config) => {
  return await updateQuery("v1/ext/laboratory", data, true, true, config);
};

export const putIssueMedicine = async (data) => {
  return await updateQuery("v1/ext/pharmacy/issue-medicine/", data, true, true);
};

export const putAddPharmacyNote = async (note) => {
  return await updateQuery("v1/ext/pharmacy/add-notes", note, true, true);
};

export const postExtLogin = async (data) => {
  return await postQuery("v1/ext/auth/login", data, true, true);
};

export const postExtPatientFeedback = async (code, hashcode, data) => {
  return await postQuery(
    `v1/ext/consultations/${code}/patient/${hashcode}`,
    data,
    false,
    true
  );
  // return qry.data.data;
};

// profile
export const getProfileById = async (id) => {
  const qry = await fetchQuery(`accounts/${id}`);
  return qry.data.data;
};

// facility
export const getFacilityById = async (id) => {
  const qry = await fetchQuery(`facilities/${id}`);
  return qry.data.data;
};

/** Care fee wallet (facility admin only). */
export const getFacilityCareFeeWallet = async (facilityId) => {
  const qry = await fetchQuery(`facilities/${facilityId}/wallet`, true);
  return qry.data.data;
};

export const getFacilityCareFeeWalletLedger = async (
  facilityId,
  { limit = 40, offset = 0 } = {}
) => {
  const qry = await fetchQuery(
    `facilities/${facilityId}/wallet/ledger?limit=${limit}&offset=${offset}`,
    true
  );
  return { data: qry.data.data, total: qry.data.total };
};

export const getAllFacilities = async () => {
  const qry = await fetchQuery(`facilities`);
  return qry.data.data;
};

export const getAllFacilitiesBranches = async () => {
  const qry = await fetchQuery(`facilities/branches`);
  return qry.data.data;
};

export const getFacilitySettings = async (id) => {
  const qry = await fetchQuery(`facilities/${id}/settings`);
  return qry.data.data;
};

export const getFacilityServices = async (id) => {
  const qry = await fetchQuery(`facilities/${id}/services`, true);
  return qry.data.data;
};

export const getFacilityBranchById = async (id) => {
  const qry = await fetchQuery(`facilities/branches/${id}`);
  return qry.data.data;
};

export const getFacilityBranches = async (facilityId) => {
  const qry = await fetchQuery(`facilities/${facilityId}/branches`);
  return qry.data.data;
};

export const getFacilityStaffs = async (facilityId) => {
  const qry = await fetchQuery(`facilities/${facilityId}/staffs`);
  if (qry?.response?.status >= 400 || !qry?.data?.data) {
    return [];
  }
  return qry.data.data;
};

export const getFacilityBranchOperatingHours = async (facilityId, branchId) => {
  const qry = await fetchQuery(
    `facilities/${facilityId}/branches/${branchId}/operating-hours`
  );
  return qry.data.data;
};

export const postFacilityBranch = async (data) => {
  return await postQuery(`facilities/branches`, data);
};

export const putFacility = async (data) => {
  return await updateQuery(`facilities`, data);
};

export const putFacilitySettings = async (id, data) => {
  return await updateQuery(`facilities/${id}/settings`, data);
};

export const putFacilityBranch = async (id, data) => {
  return await updateQuery(`facilities/branches/${id}`, data);
};

export const putMakeHQ = async (id) => {
  return await updateQuery(`facilities/branches/${id}/make-hq`);
};

export const closeBranch = async (id) => {
  return await deleteQuery(`facilities/branches/${id}`);
};

// expenses
export const getAllExpenses = async () => {
  const qry = await fetchQuery(`expenses`);
  return qry.data.data;
};

export const getExpenseById = async (id) => {
  const qry = await fetchQuery(`expenses/${id}`);
  return qry.data.data;
};

export const postNewExpense = async (data) => {
  return await postQuery(`expenses`, data);
};

export const putExpense = async (data) => {
  return await updateQuery(`expenses`, data);
};

export const deleteExpense = async (id) => {
  return await deleteQuery(`expenses/${id}`);
};

// CATEGORIES
export const getCategory = async (id) => {
  const qry = await fetchQuery(`categories/${id}`, true);
  return qry.data.data;
};

export const getAllCategories = async (type = "") => {
  const qry = await fetchQuery(`categories?type=${type}`, true);
  return qry.data.data;
};

export const postNewCategory = async (data) => {
  return await postQuery("categories", data, true);
};

export const putCategory = async (id, data) => {
  return await updateQuery(`categories/${id}`, data, true);
};

export const deleteCategory = async (id) => {
  return await deleteQuery(`categories/${id}`, true);
};

// ANALYTICS
export const getConsultationAnalytics = async () => {
  const qry = await fetchQuery(`analytics/consultations`);
  return qry.data.data;
};
export const getRevenueAnalytics = async () => {
  const qry = await fetchQuery(`analytics/revenue`);
  return qry.data.data;
};
export const getExpensesAnalytics = async () => {
  const qry = await fetchQuery(`analytics/expenses`);
  return qry.data.data;
};

// public endpoints

// fetch all Facilities
export const getAllPublicFacilities = async () => {
  const qry = await fetchQuery(`v1/facilities`, false, true, {
    headers: {
      "X-API-Key": process.env.REACT_APP_SENDER_ID,
    },
  });
  return qry.data.data;
};

// create attendance (clock-in)
export const postPublicAttendance = async (data) => {
  return await postQuery(`v1/attendance`, data, false, true, {
    headers: {
      "X-API-Key": process.env.REACT_APP_SENDER_ID,
    },
  });
};

// update attendance (clock out)
export const putPublicAttendance = async (data) => {
  return await updateQuery(`v1/attendance`, data, false, true, {
    headers: {
      "X-API-Key": process.env.REACT_APP_SENDER_ID,
    },
  });
};

// post feedback
export const postPublicFeedback = async (data) => {
  return await postQuery(`v1/feedback`, data, false, true, {
    headers: {
      "X-API-Key": process.env.REACT_APP_SENDER_ID,
    },
  });
};

// generic
export const postGenerateOTP = async (key, data) => {
  return await postQuery("accounts/generate-otp", { key, ...data }, true);
};

// memberships
export const postMemberLogin = async (data) => {
  return await postQuery("accounts/member-login", data, true);
};

export const postMembershipSponsor = async (sponsor) => {
  return await postQuery("memberships/sponsors", sponsor);
};

export const putUpdateMembershipSponsor = async (sponsor) => {
  return await updateQuery("memberships/sponsors", sponsor);
};

export const postMembershipRegistration = async (data) => {
  return await postQuery(`memberships`, data, true, false);
};

export const postMembershipSubscription = async (data) => {
  return await postQuery(`memberships`, data, true, false);
};

export const postDependantsSubscriptions = async (data) => {
  return await postQuery(`memberships/dependants`, data, true, false);
};

export const postAuthorizeFacility = async (
  patientId,
  facilityId,
  step,
  otp
) => {
  return await postQuery(
    `patients/${patientId}/authorize-facility/${facilityId}?step=${step}&otp=${otp}`,
    null,
    true
  );
};

export const postMemberReferral = async (patientId, data) => {
  return await postQuery(`patients/${patientId}/referrals`, data, true);
};

export const getMembershipSponsor = async (sponsorId) => {
  const qry = await fetchQuery(`memberships/sponsors/${sponsorId}`);
  return qry.data.data;
};

export const getAllMembers = async (id) => {
  const qry = await fetchQuery(`patients/${id}`);
  return qry.data.data;
};

export const getMembershipSubscription = async (membershipId) => {
  const qry = await fetchQuery(
    `memberships/${membershipId}?light=false`,
    true,
    false
  );
  return qry.data.data;
};

export const getMembershipBenefits = async (subscriptionId) => {
  const qry = await fetchQuery(
    `memberships/${subscriptionId}/benefits`,
    true,
    false
  );
  return qry.data.data;
};

export const getBenefitsRedemptions = async (membershipId, limit = 200) => {
  const qry = await fetchQuery(
    `memberships/${membershipId}/redemptions?limit=${limit}`
  );
  return qry.data.data;
};

export const getAllMembershipTiers = async () => {
  const qry = await fetchQuery(`memberships/tiers`);
  return qry.data.data;
};

export const getAllMembershipTierBenefits = async (tierId, identifier) => {
  const qry = await fetchQuery(
    `memberships/tiers/${tierId}/benefits?identifier=${identifier}`
  );
  return qry.data.data;
};

export const getAllMembershipPackages = async () => {
  const qry = await fetchQuery(`memberships/packages`);
  return qry.data.data;
};

export const getMembershipPackageById = async (packageId) => {
  const qry = await fetchQuery(`memberships/packages/${packageId}`);
  return qry.data.data;
};

export const getAllMembershipPlans = async () => {
  const qry = await fetchQuery(`memberships/plans`);
  return qry.data.data;
};

export const getAllMembershipPlanBenefits = async (planId, identifier) => {
  const qry = await fetchQuery(
    `memberships/plans/${planId}/benefits?identifier=${identifier}`
  );
  return qry.data.data;
};

export const getAllMembershipBenefits = async (membershipId) => {
  const qry = await fetchQuery(`memberships/${membershipId}/benefits`);
  return qry.data.data;
};

export const redeemMembershipBenefits = async (membershipId, benefits) => {
  const qry = await postQuery("memberships/benefits/redeem", {
    membershipId,
    benefits,
  });
  return qry.data;
};

export const getAllMembershipSponsors = async () => {
  const qry = await fetchQuery("memberships/sponsors");
  return qry.data.data;
};

export const getAllSponsoredMemberships = async (sponsorId) => {
  const qry = await fetchQuery(`memberships/sponsors/${sponsorId}/members`);
  return qry.data.data;
};

export const getPayoutById = async (payoutId) => {
  const qry = await fetchQuery(`memberships/payouts/${payoutId}`);
  return qry.data.data;
};

// PUBLIC API
export const getAllPublicMembershipPlans = async () => {
  const qry = await fetchQuery(`v1/memberships/plans`, true, true, {
    headers: { "X-API-Key": process.env.REACT_APP_SENDER_ID },
  });
  return qry.data.data;
};

export const postPublicMembershipRegistration = async (data) => {
  return await postQuery(`v1/memberships`, data, true, false, {
    headers: { "X-API-Key": process.env.REACT_APP_SENDER_ID },
  });
};

export const postPublicMember = async (data) => {
  return await postQuery(`v1/members`, data, true, false, {
    headers: { "X-API-Key": process.env.REACT_APP_SENDER_ID },
  });
};

export const getPublicFacilityServices = async (facilityId) => {
  const qry = await fetchQuery(
    `v1/facilities/${facilityId}/services`,
    true,
    false,
    {
      headers: { "X-API-Key": process.env.REACT_APP_SENDER_ID },
    }
  );
  return qry.data.data;
};

// CHARGES
export const getAllCharges = async (facilityId) => {
  const qry = await fetchQuery(`facilities/${facilityId}/charges`, true);
  return qry.data.data;
};

export const getCharge = async (facilityId, id) => {
  const qry = await fetchQuery(`facilities/${facilityId}/charges/${id}`, true);
  return qry.data.data;
};

export const postCharge = async (facilityId, data) => {
  return await postQuery(`facilities/${facilityId}/charges`, data, true);
};

export const putCharge = async (facilityId, chargeId, data) => {
  return await updateQuery(
    `facilities/${facilityId}/charges/${chargeId}`,
    data,
    true
  );
};

export const deleteCharge = async (facilityId, chargeId) => {
  return await deleteQuery(
    `facilities/${facilityId}/charges/${chargeId}`,
    true
  );
};

export const getAllIncidents = async (branchId) => {
  const qry = await fetchQuery(`facilities/branches/${branchId}/incidents`, true);
  return qry.data.data;
};

export const getIncident = async (branchId, id) => {
  const qry = await fetchQuery(`facilities/branches/${branchId}/incidents/${id}`, true);
  return qry.data.data;
};

export const postIncident = async (branchId, data) => {
  return await postQuery(`facilities/branches/${branchId}/incidents`, data, true);
};

export const putIncident = async (branchId, incidentId, data) => {
  return await updateQuery(
    `facilities/branches/${branchId}/incidents/${incidentId}`,
    data,
    true
  );
};

export const deleteIncident = async (branchId, incidentId) => {
  return await deleteQuery(
    `facilities/branches/${branchId}/incidents/${incidentId}`,
    true
  );
};
